document.documentElement.classList.add('js');
window.onload = loadData;


document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll('.compare-cards .card');

    const observerOptions = {
        root: null, // Use the viewport as the root
        rootMargin: '0px',
        threshold: 0.4 // Trigger when 10% of the card is visible
    };

    const observerCallback = (entries, observer) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add('visible'); // Add the visible class
                    observer.unobserve(entry.target); // Stop observing once it's visible
                }, index * 200); // Stagger the appearance by 200ms for each card
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    cards.forEach(card => {
        observer.observe(card);
    });
});

function elementExists(id) {
    return document.getElementById(id) !== null;
}



if (elementExists('hs_0e9ce872-3ee8-483c-ad1a-7a5722410353')) {
     hbspt.forms.create({
        css: '',
        portalId: '2918901',
        formId: '0e9ce872-3ee8-483c-ad1a-7a5722410353',
        goToWebinarWebinarKey: '',
        target: '#hs_0e9ce872-3ee8-483c-ad1a-7a5722410353',
        onFormReady: function ($form) {
         
        if (document.getElementsByName("conversion_page").length > 0) {
            document.getElementsByName("conversion_page")[0].value = document.referrer;
        }

        
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", emailValidation);
        } else {
            emailValidation();
        }
        },
        onFormSubmit: function ($form) {
            let firstName = $form.find('input[name="firstname"]').val();
            let companyName = $form.find('input[name="company"]').val();
           

            localStorage.setItem("firstName", firstName);
            localStorage.setItem("companyName", companyName);
        },
        onFormSubmitted: function ($form) {
            
            window.location.href = window.location.pathname + "/confirmation";
        }
    });

}
else if (elementExists('hs_b8eb7dd6-4900-426d-879c-4c3e97e6403b')) {
    hbspt.forms.create({
        css: '',
        portalId: '2918901',
        formId: 'b8eb7dd6-4900-426d-879c-4c3e97e6403b',
        goToWebinarWebinarKey: '',
        target: '#hs_b8eb7dd6-4900-426d-879c-4c3e97e6403b',
        onFormReady: function ($form) {
            
            if (document.getElementsByName("conversion_page").length > 0) {
                document.getElementsByName("conversion_page")[0].value = document.referrer;
            }

            
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", emailValidation);
            } else {
                emailValidation();
            }
        },
        onFormSubmit: function ($form) {
            let firstName = $form.find('input[name="firstname"]').val();
            let companyName = $form.find('input[name="company"]').val();
            

            localStorage.setItem("firstName", firstName);
            localStorage.setItem("companyName", companyName);
        },
        onFormSubmitted: function ($form) {
            
            window.location.href = window.location.pathname + "/confirmation";
        }
    });

}
else if (elementExists('hs_b5bfcd1c-0815-410c-947f-fde57ddc404f')) {
    hbspt.forms.create({
        css: '',
        portalId: '2918901',
        formId: 'b5bfcd1c-0815-410c-947f-fde57ddc404f',
        goToWebinarWebinarKey: '',
        target: '#hs_b5bfcd1c-0815-410c-947f-fde57ddc404f',
        onFormReady: function ($form) {
            
            if (document.getElementsByName("conversion_page").length > 0) {
                document.getElementsByName("conversion_page")[0].value = document.referrer;
            }

            //add email validation on submission
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", emailValidation);
            } else {
                emailValidation();
            }
        },
        onFormSubmit: function ($form) {
            let firstName = $form.find('input[name="firstname"]').val();
            let companyName = $form.find('input[name="company"]').val();
 
            localStorage.setItem("firstName", firstName);
            localStorage.setItem("companyName", companyName);
        },
        onFormSubmitted: function ($form) {

            window.location.href = window.location.pathname + "/confirmation";
        }
    });

}
else if (elementExists('hs_a53c9f0f-5a0c-4e08-a30d-540592a8e251')) {
    hbspt.forms.create({
        css: '',
        portalId: '2918901',
        formId: 'a53c9f0f-5a0c-4e08-a30d-540592a8e251',
        goToWebinarWebinarKey: '',
        target: '#hs_a53c9f0f-5a0c-4e08-a30d-540592a8e251',
        onFormReady: function ($form) {

            if (document.getElementsByName("conversion_page").length > 0) {
                document.getElementsByName("conversion_page")[0].value = document.referrer;
            }

            //add email validation on submission
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", emailValidation);
            } else {
                emailValidation();
            }
        },
        onFormSubmit: function ($form) {
            let firstName = $form.find('input[name="firstname"]').val();
            let companyName = $form.find('input[name="company"]').val();

            localStorage.setItem("firstName", firstName);
            localStorage.setItem("companyName", companyName);
        },
        onFormSubmitted: function ($form) {

            window.location.href = window.location.pathname + "/confirmation";
        }
    });

}



// Function to get URL parameters
function getUrlParams(url) {
    let params = {};
    let parser = new URL(url);
    let queryString = parser.search.slice(1);
    let queries = queryString.split("&");

    queries.forEach(query => {
        let [key, value] = query.split("=");
        params[key] = decodeURIComponent(value);
    });

    return params;
}

// Function to update the elements
function updateElements(params) {
    if (params.firstName) {
        document.getElementById("firstName").textContent = params.firstName;
    }
    if (params.companyName) {
        document.getElementById("companyName").textContent = params.companyName;
    }
}

// Example usage
//let currentUrl = window.location.href;
//let params = getUrlParams(currentUrl);
//updateElements(params);

function loadData() {
    let firstName = localStorage.getItem("firstName");
    let companyName = localStorage.getItem("companyName");

    if (firstName) {
        if (elementExists('firstName')) {
            document.getElementById("firstName").textContent = firstName;
        }
    }
    if (companyName) {
        if (elementExists('companyName')) {
            document.getElementById("companyName").textContent = companyName;
        }
    }
}



